<template>
  <div>
    <CCard class="mob-pd-0px">
      <CCardHeader class="grey-header d-flex mob-flex-column ai-center">
        <CRow class="flex-flow-column">
          <CCol>
            <!-- <strong v-if="GET_SELECTED_CONTRACT==null">{{ $t("addContract.addNewContract") }}</strong>
            <strong v-else>{{ $t("addContract.EditContract") }}</strong> -->

            <strong v-if="contract.contractcode" class="text-transform-uppercase">{{contract.contractcode}}</strong>
              <strong v-else>{{ $t("addContract.addNewContract") }}</strong>
          </CCol>

<!--           <p class="desc" >{{ // $t("contract.desc") }}</p>-->
           <p class="desc" v-if="contract.description">{{contract.description}}</p>
           <p class="desc" v-else>{{ $t("addContract.desc") }}</p>
        </CRow>

        <button v-if="GET_SELECTED_CONTRACT" @click.stop="navigateToFareView()" type="button" 
        class="btn action-c-btn btn-success ml-auto mr-15px">{{'View Fare'}}</button>

        
      </CCardHeader>
<ValidationObserver v-slot="{ handleSubmit }">
                                    <!-- @submit.prevent="handleSubmit(paxPageSubmitted)" -->
                                    <form @submit.prevent="handleSubmit(toSaveContract)"  >
      <CCardBody class="user-manage-table pt-0px max-width-550 m-auto">
        <!-- :startDate="getStartingDate()" -->
<div class="max-w-850">
    <div class="row mt-20px mb-20px">
      <div v-if="GET_SELECTED_CONTRACT!=null"  class="col-md-12 col-sm-12 mb-10px">
        <span>
         
            {{$t('addContract.status')}}
        
        </span>
        <cStatusButton
          class="generate-ex-btn label-margin-unset"
          :isConfirm="false"
          :defaultStatus="GET_SELECTED_CONTRACT!=null? GET_SELECTED_CONTRACT.isactive : contract.isActive"
          @change="contract.isActive=!contract.isActive"
          :label="{checked: $t('addContract.active'), unchecked: $t('addContract.inactive')}"
        ></cStatusButton>        
      </div>
      <br />
        <div v-if="GET_SELECTED_CONTRACT!=null">

        </div>
        <div v-else class="col-md-12 col-sm-12 mb-10px">
            <cTextInputComponent
                    :id="$t('addContract.flightSch')"
                    :ref="$t('addContract.flightSch')"
                    :toEmit="true"
                    @caughtError="scrollToElement"
                    v-model="contract.contractcode"
                    :placeholder="$t('addContract.flightSchPl')"
                    :name="$t('addContract.flightSch')"
                    :label="$t('addContract.flightSch')"
                    class=""
                    rules="required|noInitialSpace|minimum:3|max:50"
            />
        </div>
        <div v-if="GET_SELECTED_CONTRACT!=null"></div>
        <div v-else class="col-md-12 col-sm-12 mb-10px">
            <cTextInputComponent
                    v-model="contract.description"
                    :id="$t('addContract.description')"
                    :ref="$t('addContract.description')"
                    :toEmit="true"
                    @caughtError="scrollToElement"
                    :placeholder="$t('addContract.descPl')"
                    :name="$t('addContract.description')"
                    :label="$t('addContract.description')"
                    rules="required|noInitialSpace|minimum:10|max:300"
                    class=" "
            />
        </div>
        <!-- <div class="col-md-12 col-sm-12 mb-10px">

            <div class="">

                <div class="row">
                    <div class="col-7">
                        <label>{{$t('addContract.airlineCode')}}</label>
                        <div class="">
                        <ValidationProvider class="w-100"
                                tag="div"
                                rules="required"
                                v-slot="{ errors }"
                        >
                            <multiselect
                                    :searchable="false"
                                    :close-on-select="true"
                                    :track-by="'airline_code'"
                                   
                                    v-model="contract.airline"
                                    :show-labels="false"
                                    @input="onAirlineChange"
                                    :options="airlineOption"
                                    :placeholder="$t('addContract.airlinePl')"
                            >
                                <template slot="singleLabel" slot-scope="{ option }">
                                    <div class="d-flex">
                                     <span>{{ option['airline_code'] }}</span>
                                        <strong class="right ml-auto">
                                          {{
                                          option['airline_name']
                                          }}
                                        </strong>
                                    </div>
                                </template>
                                <template slot="option" slot-scope="props">
                                    <div class="d-flex">
                                        <span>{{ props.option['airline_code'] }}</span>
                                        <strong class="right ml-auto">
                                          {{
                                          props.option['airline_name']
                                          }}
                                        </strong>
                                    </div>
                                </template>
                                <span slot="noResult"><strong>{{ $t("noMatchFound.noMatchFound") }}</strong></span>
                            </multiselect>
                            <div v-if="errors && errors[0]" class="invalid-feedback icon">
                                <div v-if="contract.airline == null">
                                    <span>{{ errors[0] }}</span>
                                </div>
                            </div>
                        </ValidationProvider>
                        </div>
                    </div>
                </div>

            </div>
        </div> -->
        
                
        <div class="col-md-12 col-sm-12 mb-10px">
            <div class="row ">
                <div class="col-12">
                    <label>{{$t('addContract.travelDate')}}</label>
                    <div class="">
                    <div class="date w-100">
                        <div class="ext-date-wrapper w-100">
                            <v-md-date-range-picker
                                    :start-date="new Date(contract.travelDate.from).toString()"
                                    :end-date="new Date(contract.travelDate.to).toString()"
                                    :disableBefore="new Date().toString()"
                                    :autoApply="true"
                                    :showYearSelect="true"
                                    :maxYear="getMaxYear()"
                                    :minYear="getMinYear()"
                                    @change="onChangeTravelDate"
                                    :allowPastPresets="false"

                            >
                                <template slot="input">
                                    <datePickerInput :fromDate="new Date(contract.travelDate.from).toString()"
                                                     :toDate="new Date(contract.travelDate.to).toString()" :fromLabel="$t('addContract.fromLabel')" :toLabel="$t('addContract.toLabel')"/>
                                </template>
                            </v-md-date-range-picker>
                        </div></div>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-md-12 col-sm-12 mb-10px">
            <div class="row ">
                <div class="col-12">
            <label>{{$t('addContract.ticketingDate')}}</label>
                    <div class="">
            <div class="date w-100">
                <div class="ext-date-wrapper">
                  <!-- :disableAfter="new Date(contract.travelDate.to).toString()"
                            :disableBefore="new Date().toString()" -->
                    <v-md-date-range-picker
                            v-if="showTicketDate"
                            :start-date="new Date(contract.ticketingDate.from).toString()"
                            :end-date="new Date(contract.ticketingDate.to).toString()"
                            
                            :autoApply="true"
                            :showYearSelect="true"
                            :maxYear="getMaxYear()"
                            :minYear="getMinYear()"
                            @change="onChangeTicketingDate"
                    >
                        <template slot="input">
                            <datePickerInput :fromDate="contract.ticketingDate.from.toString()"
                                             :toDate="new Date(contract.ticketingDate.to).toString()" :fromLabel="'From date'" :toLabel="'To date'"/>
                        </template>
                    </v-md-date-range-picker>
                </div></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-12 col-sm-12 mb-10px">
            <div class="">
                <div class="d-flex">


                <label for="">

                </label>
                    <div class="">
                <div class="checkbox-all d-flex mt-10px">
                    <div class="checkbox d-flex align-center align-item-center">
                        <input id="crs" type="checkbox" :checked="contract.isCrs" v-on:input="onFareOnlyChange()" />
                        <span @click="onFareOnlyChange()" class="ml-10px text-justify c-pointer d-flex align-item-center">{{' '+ $t('addContract.enableGds') }}</span>
                    </div>
                </div>

                </div>
                </div>

            </div>

        </div>
        <div class="col-md-12 col-sm-12 mb-10px ">
            <div class="row">
                <div class="col-12" v-if="contract.isCrs">

                        <label>{{$t('addContract.gds')}}</label>
                    <div class="">
                        <ValidationProvider class="w-100"
                                tag="div"
                                rules="required"
                                v-slot="{ errors }"
                        >

                            <multiselect
                                    :searchable="false"
                                    :close-on-select="true"
                                    :track-by="'providerid'"
                                    :label="'providertype'"
                                    v-model="contract.providerid"
                                    :show-labels="false"
                                    @input="onCrsChange"
                                    :options="crsOption"
                                    :placeholder="$t('addContract.gdsPl')"
                            >
                                <template slot="option" slot-scope="props">
                                    <div class="d-flex">
                                        <span>{{ props.option['providertype'] }}</span>
                                        <!-- <strong class="right ml-auto">
                                        {{
                                        props.option['contractcode']
                                        }}
                                        </strong>-->
                                    </div>
                                </template>
                                <span slot="noResult"><strong>{{ $t("noMatchFound.noMatchFound") }}</strong></span>
                            </multiselect>
                            <div v-if="errors && errors[0]" class="invalid-feedback icon">
                                <div v-if="contract.providerid== null">
                                    <span>{{ errors[0] }}</span>
                                </div>
                            </div>
                        </ValidationProvider>
                    </div>

                </div>
            </div>
        </div>

        <div class="col-md-12 col-sm-12 mb-10px ">
               <div class="row">
                <div class="col-12" >
                        <div :class={rotate:isAdvanceSettings}  @click="isAdvanceSettings=!isAdvanceSettings" class="link-drop-btn">
                               <span> {{$t('addContract.advSettings')}}</span>
                            </div>
         

                </div>
            </div>
        </div>
        <div v-if="isAdvanceSettings" class="col-md-12 col-sm-12 mb-10px ">
  <div class="col-md-12 col-sm-12 mb-10px ">
            <div class="row">
                <div class="col-12" >
                    <div class="">
                       <label>{{$t('addContract.isDepBasedCurrency')}}</label>
                        <CRow class="min-h-40px d-flex align-item-center">
                            <CCol md="6" v-for="(depCurr,index) in lsDepBasedCurrency" :key="index">
                                <cRadioButton

                                        :key="depCurr.code"
                                        :name="depCurr.code"
                                        :value="depCurr.code"
                                        :label="depCurr.name"
                                        v-on:input="updateDepBasedCurr(index)"
                                        rules="required"
                                        :selValue="lsDepBasedCurrency[selDepBasedAirport]"
                                />
                            </CCol>

                        </CRow>
                    </div>

                </div>
            </div>
        </div>
      
           <div class="col-md-12 col-sm-12 mb-10px">

            <div class="">

                <div class="row">
                    <div class="col-7">
                        <!-- <label>{{$t('addContract.nucCurrencyLabel')}}</label> -->
                        <div class="">
                       <cOrgCurrencyDp
                                            v-if="isOrgCurrencyDp"
                                            v-model="contract.nuclearCurrency"
                                            :defaultCurrency="defaultCurrency"
                                            :ctrlCode="'id'"
                                            :isShowCode="true"
                                            :isMultiple="false"
                                            :isSearchable="false"
                                            :isAllowEmpty="false"
                                            rules="required"
                                            :label="$t('addContract.nucCurrencyLabel')"
                                            @input="getSelectedCurrency"
                                            class=" m-0 "
                                    ></cOrgCurrencyDp>
                        </div>
                    </div>
                </div>

            </div>
        </div>         
        <div class="col-md-12 col-sm-12 mb-10px">
                        <label>{{$t('addContract.taxSetup')}}</label>

            <div class="">

                <div class="row">
                    <div class="col-7">
                        <label>{{$t('addContract.homeCountry')}}</label>
                        <div class="">
                         <cDropDown
                             class="w-100"
                                key="mobilecode"
                                :isAllowEmpty="false"
                                :defaultCountryCode="defaultCountryCode"
                                :ctrlName="'value'"
                                :ctrlCode="'value'"
                                :isShowCode="false"
                                :isMultiple="false"
                                :isSearchable="true"
                                :url="getCountryServiceURL()"
                                rules="required"
                                :selValue="contract.country"
                                v-on:input="onCountryChange"
                        />
                        </div>
                    </div>
                </div>

            </div>
        </div>
        </div>
    </div>









</div>
        

<!--        <cTextInputComponent-->
<!--          v-model="contract.contractcode"-->
<!--          :placeholder="$t('addContract.flightSchPl')"-->
<!--          :name="$t('addContract.flightSch')"-->
<!--          :label="$t('addContract.flightSch')"-->
<!--          rules="required"-->
<!--        />-->

<!--        <cTextInputComponent-->
<!--          v-model="contract.description"-->
<!--          :placeholder="$t('addContract.descPl')"-->
<!--          :name="$t('addContract.description')"-->
<!--          :label="$t('addContract.description')"-->
<!--          rules="required"-->
<!--        />-->
<!--        <label>{{$t('addContract.airlineCode')}}</label>-->
<!--         <ValidationProvider-->
<!--    tag="div"-->
<!--    rules="required"-->
<!--    v-slot="{ errors }"-->
<!--  >-->
<!--        <multiselect-->
<!--          :searchable="false"-->
<!--          :close-on-select="true"-->
<!--          :track-by="'airline_code'"-->
<!--          :label="'airline_code'"-->
<!--          v-model="contract.airline"-->
<!--          :show-labels="false"-->
<!--          @input="onAirlineChange"-->
<!--          :options="airlineOption"-->
<!--          :placeholder="$t('addContract.airlinePl')"-->
<!--        >-->
<!--          <template slot="option" slot-scope="props">-->
<!--            <div class="d-flex">-->
<!--              <span>{{ props.option['airline_code'] }}</span>-->
<!--              &lt;!&ndash; <strong class="right ml-auto">-->
<!--                {{-->
<!--                props.option['contractcode']-->
<!--                }}-->
<!--              </strong>&ndash;&gt;-->
<!--            </div>-->
<!--          </template>-->
<!--        </multiselect>-->
<!--        <div v-if="errors && errors[0]" class="invalid-feedback icon">-->
<!--            <div v-if="contract.airline == null">-->
<!--              <span>{{ errors[0] }}</span>-->
<!--            </div>-->
<!--          </div>-->
<!--         </ValidationProvider>-->
<!--        <div>{{$t('addContract.travelDate')}}</div>-->
<!--        <div class="date">-->
<!--                                <div class="ext-date-wrapper box-shadow">-->
<!--        <v-md-date-range-picker-->
<!--     :start-date="new Date(contract.travelDate.from).toString()"-->
<!--    :end-date="new Date(contract.travelDate.to).toString()"-->
<!--    :autoApply="true"-->
<!--    :showYearSelect="true"-->
<!--    :maxYear="getMaxYear()"-->
<!--    :minYear="getMinYear()"-->
<!--    @change="onChangeTravelDate"-->
<!--    -->
<!--  >-->
<!--  <template slot="input">-->
<!--     <datePickerInput :fromDate="new Date(contract.travelDate.from).toString()" -->
<!--     :toDate="new Date(contract.travelDate.to).toString()" :fromLabel="'From date'" :toLabel="'To date'"/>-->
<!--  </template>-->
<!--</v-md-date-range-picker>-->
<!--                                </div></div>-->

<!--        <div>{{$t('addContract.ticketingDate')}}</div>-->
<!--        -->

<!--                        -->

<!--                            <div class="date">-->
<!--                                <div class="ext-date-wrapper box-shadow">-->
<!--                                  -->
<!--        <v-md-date-range-picker-->
<!--     :start-date="contract.ticketingDate.from.toString()"-->
<!--    :end-date="contract.ticketingDate.to.toString()"-->
<!--    :autoApply="true"-->
<!--    :showYearSelect="true"-->
<!--    :maxYear="getMaxYear()"-->
<!--    :minYear="getMinYear()"-->
<!--    @change="onChangeTicketingDate"-->
<!--  >-->
<!--  <template slot="input">-->
<!--     <datePickerInput :fromDate="contract.ticketingDate.from.toString()" -->
<!--     :toDate="new Date(contract.ticketingDate.to).toString()" :fromLabel="'From date'" :toLabel="'To date'"/>-->
<!--  </template>-->
<!--</v-md-date-range-picker>-->
<!--                                </div></div>-->

<!--        <div class="checkbox-all d-flex">-->
<!--          <div class="checkbox">-->
<!--            <input id="crs" type="checkbox" :checked="contract.isCrs" v-on:input="onFareOnlyChange()" />-->
<!--            {{ $t('addContract.enableGds') }}-->
<!--             </div>-->
<!--          </div>-->
<!--          <div v-if="contract.isCrs">-->
<!--              <label>{{$t('addContract.gds')}}</label>-->
<!--           <ValidationProvider-->
<!--    tag="div"-->
<!--    rules="required"-->
<!--    v-slot="{ errors }"-->
<!--  >-->

<!--          <multiselect-->
<!--            :searchable="false"-->
<!--            :close-on-select="true"-->
<!--            :track-by="'providerid'"-->
<!--            :label="'providertype'"-->
<!--            v-model="contract.providerid"-->
<!--            :show-labels="false"-->
<!--            @input="onCrsChange"-->
<!--            :options="crsOption"-->
<!--            :placeholder="$t('addContract.gdsPl')"-->
<!--          >-->
<!--            <template slot="option" slot-scope="props">-->
<!--              <div class="d-flex">-->
<!--                <span>{{ props.option['providertype'] }}</span>-->
<!--                &lt;!&ndash; <strong class="right ml-auto">-->
<!--                {{-->
<!--                props.option['contractcode']-->
<!--                }}-->
<!--                </strong>&ndash;&gt;-->
<!--              </div>-->
<!--            </template>-->
<!--          </multiselect>-->
<!--          <div v-if="errors && errors[0]" class="invalid-feedback icon">-->
<!--            <div v-if="contract.providerid== null">-->
<!--              <span>{{ errors[0] }}</span>-->
<!--            </div>-->
<!--          </div>-->
<!--          </ValidationProvider>-->
<!--        </div>-->
        <cAlertModal
                v-if="isShowAlertModal"
                :key="'CA'+alertCount"
                :buttonList="modalButton"
                :status="modalStatus"
                :isShowIcon="true"
                :show="isShowAlertModal"
                :desc="confirmTxt"
        ></cAlertModal>

        <CRow>
          <CAlert v-if="alertValue" show color="danger">
            <div v-if="alertValue&&alertValue.hasOwnProperty('valueList')">
              <p v-for="(value,index) in alertValue.valueList" :key="index">{{value}}</p>
            </div>
            <div v-if="alertValue&&alertValue.hasOwnProperty('codeList')">
              <span>{{$t("cAlert.errorCode")+' : '}}</span>
              <span v-for="(code,index) in alertValue.codeList" :key="index">{{code +' '}}</span>
            </div>
            <div v-if="alertValue&&alertValue.constructor==String">
              <p>{{alertValue}}</p>
            </div>
          </CAlert>
        </CRow>
        <!-- table filter hidded
        tableFilter-->
        <!-- <button class="mf-success-round-btn">Apply</button> -->
        <div class="d-flex" v-if="GET_SELECTED_CONTRACT" >
          <CButton @click="navToScheduleAll"
            size="sm"
            color="success"
            class=" btn-lit-blue mob-w100 "
          >{{$t('addContract.addFlightSchedule')}}</CButton>
          <CButton @click="navToFareuploadAll"
            size="sm"
            color="success"
            class="m-auto btn-lit-blue mob-w100"
          >{{$t('addContract.addFareUpload')}}</CButton>
          <CButton @click="navToFareRuleAll"
            size="sm"
            color="success"
            class="btn-lit-blue mob-w100"
          >{{$t('addContract.addFareRule')}}</CButton>
        </div>
      </CCardBody>
      <CCardFooter>
        <CRow class="justify-content-end">
          <CButton @click="navToContractPage()" color="danger" class="action-c-btn mr-15px">{{$t('addContract.cancelBtn')}}</CButton>
          <CButton
            col="12"
            type="submit"
            color="success removewrap"
            class="action-c-btn mr-15px"
          >{{ GET_SELECTED_CONTRACT?  $t('addContract.update'):$t('addContract.saveBtn')}}</CButton>
        </CRow>
      </CCardFooter>
       </form>
                                </ValidationObserver>
    </CCard>
  </div>
</template>

<script>
import router, { navigate, updateDataEdited } from "../../../router/index";
import cTextInputComponent from "../../../components/form/cTextInputComponent";
import { mapGetters, mapActions } from "vuex";
import { ValidationProvider } from "vee-validate";

import { PATHNAME, COMPONENT_NAME,DATE_TIME_FORMAT,
        ALERT_MODAL_STATUS} from "../../../util/constants";
import apiCreateContract from "../../../services/apiCreateContract";
import apiGetAllAirline from "../../../services/apiGetAllAirline";
import apiGetCrsProviders from "../../../services/apiGetCrsProviders";
import apiUpdateContract from "../../../services/apiUpdateContract"
import Logger from "../../../services/logger";
import SERVICE_URL, {
  FILE_NAME,
  LOG_TYPE,
  HTTP_CODES
} from "../../../config/API_DATA";
import cAlertModal from "../../../components/form/cAlertModal"
import {
  VALIDATE_SUCCESS_RES,
  getErrorMessage
} from "../../../util/apiValidate";
import {
  handleJWT,
  getErrorAlertValue,
  addClassToBody,
  removeClassBody,
  OrderByList
} from "../../../util/util";
import BaseConfiguration from "../../../config/base.js";
import cStatusButton from "../../../components/form/cStatusButton";
import HotelDatePicker from "vue-range-datechooser";
import multiselect from "vue-multiselect";
import { isPastDate } from "../../../util/date/dateFunctions";

import {ValidationObserver, localize, Validator} from "vee-validate";
import {VMdDateRangePicker} from "material-vue-date-picker";
import datePickerInput from "../../../components/datePicker/datePickerInput";
import cDropDown from "../../../components/form/cDropDown";
    import cRadioButton from "../../../components/form/cRadioButton";
    import {i18n} from "../../../plugins/i18n.js";
    import cOrgCurrencyDp from "../../../components/currency/cOrgCurrencyDp";


export default {
  name: COMPONENT_NAME.CONTRACT_NEW,
  components: {
    
    ValidationProvider,
            ValidationObserver,
    datePickerInput,
       VMdDateRangePicker,
    cStatusButton,
    HotelDatePicker,
    cTextInputComponent,
    multiselect,
    cAlertModal,
    cDropDown,
    cRadioButton,
    cOrgCurrencyDp
  },

  data: () => {
    return {
      alertValue: null,
      showTicketDate: true,
      airlineOption: [],
      crsOption: [],
      contract: {
        isCrs: false,
        contractcode: null,
        description: null,
        airline: null,
        travelDate: {
          from: new Date(),
          to: new Date()
        },
        ticketingDate: {
          from: new Date(),
          to: new Date()
        },
        providerid: null,
        country:null,
        nuclearCurrency:null,
        departureCurrency:true,
        isActive: true
      },
      modalStatus: ALERT_MODAL_STATUS.INFO,
                modalButton: null,
                isShowAlertModal: false,
        defaultCountryCode: BaseConfiguration.defaultCountryValue,
              defaultCurrency: BaseConfiguration.defaultCurrencyObj.code,
              selDepBasedAirport:0,
              isOrgCurrencyDp:true,
              isAdvanceSettings:true,

   lsDepBasedCurrency: [
        {
          name: i18n.tc("addContract.yes"),
          code: 1,
          isActive: true
        },
        {
          name: i18n.tc("addContract.no"),
          code: 2,
          isActive: false
        }
      ],
    };
  },

  methods: {
    scrollToElement(pRef) {
                var el = null;
                if(pRef == this.$t('addContract.flightSch')) { 
                     el = this.$refs[this.$t('addContract.flightSch')];
                }
                if(pRef == this.$t('addContract.description')) { 
                     el = this.$refs[this.$t('addContract.description')];
                }
                
                if (el) {
                   
                    if(el[0]){
                        el[0].$el.scrollIntoView({ behavior: "smooth" });
                    }else{
                        el.$el.scrollIntoView({ behavior: "smooth" });
                    }
                }
  },
getSelectedCurrency(pCurrency) {
      try {
        if (BaseConfiguration.isDebug) console.log("getSelectedCurrency");
        if (pCurrency) {
          this.contract.nuclearCurrency = pCurrency;
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TAX_SETUP,
          "error in getSelectedCurrency",
          err.toString(),
          "getSelectedCurrency",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

        navigateToFareView() {
      try {
        if (BaseConfiguration.isDebug) console.log("navigateToFareView");
        
        navigate(PATHNAME.FARE_VIEW);
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.CONTRACT_NEW,
          "error in navigateToFareView",
          err.toString(),
          "navigateToFareView",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

        updateDepBasedCurr(pIndex) {
      try {
        if (BaseConfiguration.isDebug) console.log("updateDepBasedCurr");
        this.selDepBasedAirport = pIndex;
        for (let i = 0; i < this.lsDepBasedCurrency.length; i++) {
          if (i != pIndex) {
            this.lsDepBasedCurrency[i].isActive = false;
          }
        }

        this.lsDepBasedCurrency[pIndex].isActive = true;
         this.contract.departureCurrency=this.lsDepBasedCurrency[0].isActive;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.CONTRACT_NEW,
          "error in updateDepBasedCurr",
          err.toString(),
          "updateDepBasedCurr",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
       onCountryChange(pSelCountry) {
      try {
        if (BaseConfiguration.isDebug) console.log("onCountryChange");
        this.contract.country = pSelCountry;
         
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.CONTRACT_NEW,
          "error in onCountryChange",
          err.toString(),
          "onCountryChange",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    getCountryServiceURL() {
      if (BaseConfiguration.isDebug) console.log("getCountryServiceURL");
      return SERVICE_URL.GET_COUNTRY_LIST;
    },
    getMinYear() {
         let retValue;
          try {
            if(BaseConfiguration.isDebug) console.log("getMinYear");
           retValue=(new Date().getFullYear()-10)+'';
      
          } catch (err) {
                  let body = Logger.buildRequest(
                    COMPONENT_NAME.CONTRACT_NEW,
                    "error in getMinYear",
                    err.toString(),
                    "getMinYear",
                    LOG_TYPE.ERROR
                  );
                  Logger.getResponse(body);
                }
            return retValue;
          }, 
      getMaxYear() {
         let retValue;
          try {
            if(BaseConfiguration.isDebug) console.log("getMaxYear");
           retValue=(new Date().getFullYear()+1)+'';
      
          } catch (err) {
                  let body = Logger.buildRequest(
                    COMPONENT_NAME.CONTRACT_NEW,
                    "error in getMaxYear",
                    err.toString(),
                    "getMaxYear",
                    LOG_TYPE.ERROR
                  );
                  Logger.getResponse(body);
                }
            return retValue;
          }, 
          onChangeTravelDate(pDateList) {
          try {
            if(BaseConfiguration.isDebug) console.log("onChangeDate");
          //  console.error(pDateList)
          this.showTicketDate = false;
           this.contract.travelDate.from=!isPastDate(pDateList[0]._d) ? pDateList[0]._d : new Date() ;
             this.contract.travelDate.to=!isPastDate(pDateList[1]._d) ? pDateList[1]._d : new Date() ;
            // this.showTicketDate = true;
             let that = this;
                        setTimeout(function () {
                            that.showTicketDate = true;
                        });
          } catch (err) {
                  let body = Logger.buildRequest(
                    COMPONENT_NAME.CONTRACT_NEW,
                    "error in onChangeDate",
                    err.toString(),
                    "onChangeDate",
                    LOG_TYPE.ERROR
                  );
                  Logger.getResponse(body);
                }
            
          }, 
          
           onChangeTicketingDate(pDateList) {
          try {
            if(BaseConfiguration.isDebug) console.log("onChangeDate");
         
            // this.contract.ticketingDate.from=isPastDate(pDateList[0]._d) ? new Date() : isPastDate(pDateList[0]._d,this.contract.travelDate.from) ? pDateList[0]._d : this.contract.travelDate.from;
           
            //  this.contract.ticketingDate.to=isPastDate(pDateList[1]._d) ? new Date() : isPastDate(pDateList[1]._d,this.contract.travelDate.from) ? pDateList[1]._d : this.contract.travelDate.from;

              this.contract.ticketingDate.from=pDateList[0]._d;
               this.contract.ticketingDate.to=pDateList[1]._d;
          } catch (err) {
                  let body = Logger.buildRequest(
                    COMPONENT_NAME.CONTRACT_NEW,
                    "error in onChangeDate",
                    err.toString(),
                    "onChangeDate",
                    LOG_TYPE.ERROR
                  );
                  Logger.getResponse(body);
                }
            
          }, 
    
    navToFareRuleAll() {
        try {
          if(BaseConfiguration.isDebug) console.log("navToFareRuleAll");
          updateDataEdited(false);
         navigate(PATHNAME.FARE_RULE_ALL);
    
    
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.CONTRACT_NEW,
                  "error in navToFareRuleAll",
                  err.toString(),
                  "navToFareRuleAll",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
         
        },

    navToFareuploadAll() {
        try {
          if(BaseConfiguration.isDebug) console.log("navToFareuploadAll");
          updateDataEdited(false);
         navigate(PATHNAME.FARE_UPLOAD_ALL)
    
    
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.CONTRACT_NEW,
                  "error in navToFareuploadAll",
                  err.toString(),
                  "navToFareuploadAll",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
         
        }, 
    
    navToScheduleAll() {
        try {
          if(BaseConfiguration.isDebug) console.log("navToScheduleAll");
          updateDataEdited(false);
         navigate(PATHNAME.SCHEDULE_ALL)
    
    
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.CONTRACT_NEW,
                  "error in navToScheduleAll",
                  err.toString(),
                  "navToScheduleAll",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
         
        }, 
    
    // getTravelFromDate(pDate) {
    //   try {
    //     if (BaseConfiguration.isDebug) console.log("getTravelFromDate");
    //     // let date=  subDays(new Date(),60000);
    //     this.contract.travelDate.from = pDate;
    //   } catch (err) {
    //     let body = Logger.buildRequest(
    //       COMPONENT_NAME.CONTRACT_NEW,
    //       "error in getTravelFromDate",
    //       err.toString(),
    //       "getTravelFromDate",
    //       LOG_TYPE.ERROR
    //     );
    //     Logger.getResponse(body);
    //   }
    // },
    // getTravelToDate(pDate) {
    //   try {
    //     if (BaseConfiguration.isDebug) console.log("getTravelToDate");
    //     // let date=  subDays(new Date(),60000);
    //     this.contract.travelDate.to = pDate;
    //   } catch (err) {
    //     let body = Logger.buildRequest(
    //       COMPONENT_NAME.CONTRACT_NEW,
    //       "error in getTravelToDate",
    //       err.toString(),
    //       "getTravelToDate",
    //       LOG_TYPE.ERROR
    //     );
    //     Logger.getResponse(body);
    //   }
    // },
    // getTicketingToDate(pDate) {
    //   try {
    //     if (BaseConfiguration.isDebug) console.log("getTicketingToDate");
    //     // let date=  subDays(new Date(),60000);
    //     this.contract.ticketingDate.to = pDate;
    //   } catch (err) {
    //     let body = Logger.buildRequest(
    //       COMPONENT_NAME.CONTRACT_NEW,
    //       "error in getTicketingToDate",
    //       err.toString(),
    //       "getTicketingToDate",
    //       LOG_TYPE.ERROR
    //     );
    //     Logger.getResponse(body);
    //   }
    // },
    // getTicketingFromDate(pDate) {
    //   try {
    //     if (BaseConfiguration.isDebug) console.log("getTicketingFromDate");
    //     // let date=  subDays(new Date(),60000);
    //     this.contract.ticketingDate.from = pDate;
    //   } catch (err) {
    //     let body = Logger.buildRequest(
    //       COMPONENT_NAME.CONTRACT_NEW,
    //       "error in getTicketingFromDate",
    //       err.toString(),
    //       "getTicketingFromDate",
    //       LOG_TYPE.ERROR
    //     );
    //     Logger.getResponse(body);
    //   }
    // },

    // getStartingDate() {
    //   try {
    //     if (BaseConfiguration.isDebug) console.log("getStartingDate");
    //     // let date=  subDays(new Date(),60000);
    //     let date = new Date(null);
    //     return date;
    //   } catch (err) {
    //     let body = Logger.buildRequest(
    //       COMPONENT_NAME.CONTRACT_NEW,
    //       "error in getStartingDate",
    //       err.toString(),
    //       "getStartingDate",
    //       LOG_TYPE.ERROR
    //     );
    //     Logger.getResponse(body);
    //   }
    // },

    assigni18nObjByLang() {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("assigni18nObjByLang");

        retValue = {
          night: this.$t("flightDatePicker.night"),
          nights: this.$t("flightDatePicker.nights"),
          "day-names": [
            this.$t("flightDatePicker.sun"),
            this.$t("flightDatePicker.mon"),
            this.$t("flightDatePicker.tue"),
            this.$t("flightDatePicker.wed"),
            this.$t("flightDatePicker.thur"),
            this.$t("flightDatePicker.fri"),
            this.$t("flightDatePicker.sat")
          ],
          "check-in": "",
          "check-out": "",
          "month-names": [
            this.$t("flightDatePicker.jan"),
            this.$t("flightDatePicker.feb"),
            this.$t("flightDatePicker.mar"),
            this.$t("flightDatePicker.apr"),
            this.$t("flightDatePicker.may"),
            this.$t("flightDatePicker.jun"),
            this.$t("flightDatePicker.july"),
            this.$t("flightDatePicker.aug"),
            this.$t("flightDatePicker.sep"),
            this.$t("flightDatePicker.oct"),
            this.$t("flightDatePicker.nov"),
            this.$t("flightDatePicker.dec")
          ]
        };
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.CONTRACT_NEW,
          "error in assigni18nObjByLang",
          err.toString(),
          "assigni18nObjByLang",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    navToContractPage() {
      try {
        if (BaseConfiguration.isDebug) console.log("navToContractPage");
        navigate(PATHNAME.CONTRACT_ALL);
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.CONTRACT_NEW,
          "error in navToContractPage",
          err.toString(),
          "navigateToAddContract",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    async createContract() {
      if (BaseConfiguration.isDebug) console.log("CreateContract");
      let returnValue;
      try {
        this.isShowAlertModal = false;
        this.formatDates(this.contract)
        updateDataEdited(false);
        let CreateContractReq = apiCreateContract.buildRequest(this.contract); //constant
        this.isShowAlertModal = false;
        if (CreateContractReq != null) {
          let CreateContractRes = await apiCreateContract.getResponse(
            CreateContractReq
          );
          if (VALIDATE_SUCCESS_RES(CreateContractRes)) {
            returnValue = CreateContractRes.data.data;
            this.showAlertModal(
                                ALERT_MODAL_STATUS.SUCCESS,
                                this.$t("addContract.addSuccess")
                            );
                            this.alertValue=null;
          } else {
            let error = getErrorMessage(CreateContractRes);
           
            let isJwt = handleJWT(error);
            if (!isJwt) {
            this.alertValue = getErrorAlertValue(error,true,true);            }
             this.showAlertModal(
              ALERT_MODAL_STATUS.FAIL,
              this.alertValue
            );
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CONTRACT,
          "error in  getCreateContract",
          err.toString(),
          "getCreateContract()",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return returnValue;
    },

    formatDates(pContractObj){
      pContractObj.travelDate.from = this.$options.filters.formatDate(pContractObj.travelDate.from, DATE_TIME_FORMAT.API_DATE_FORMAT);
        pContractObj.travelDate.to = this.$options.filters.formatDate(pContractObj.travelDate.to, DATE_TIME_FORMAT.API_DATE_FORMAT);
        pContractObj.ticketingDate.from = this.$options.filters.formatDate(pContractObj.ticketingDate.from, DATE_TIME_FORMAT.API_DATE_FORMAT);
        pContractObj.ticketingDate.to = this.$options.filters.formatDate(pContractObj.ticketingDate.to, DATE_TIME_FORMAT.API_DATE_FORMAT);
    },

    async updateContract() {
      if (BaseConfiguration.isDebug) console.log("updateContract");
      let returnValue;
      try {
        this.isShowAlertModal = false;
        this.formatDates(this.contract)
        updateDataEdited(false);
        let updateContractReq = apiUpdateContract.buildRequest(this.GET_SELECTED_CONTRACT,this.contract); //constant

        if (updateContractReq != null) {
          let updateContractRes = await apiUpdateContract.getResponse(
            updateContractReq
          );
          if (VALIDATE_SUCCESS_RES(updateContractRes)) {
            returnValue = updateContractRes.data.data;
            
                            this.showAlertModal(
                                ALERT_MODAL_STATUS.SUCCESS,
                                this.$t("addContract.editSuccess")
                            );
                            this.alertValue=null;
          } else {
            let error = getErrorMessage(updateContractRes);
            
            let isJwt = handleJWT(error);
            if (!isJwt) {
             this.alertValue = getErrorAlertValue(error,true,true);
            }
            this.showAlertModal(
              ALERT_MODAL_STATUS.FAIL,
              this.alertValue
            );
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CONTRACT,
          "error in  getUpdateContract",
          err.toString(),
          "getUpdateContract()",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return returnValue;
    },

    async getAllAirline() {
      if (BaseConfiguration.isDebug) console.log("GetAllAirline");
      let returnValue;
      try {
        let GetAllAirlineReq = apiGetAllAirline.buildRequest(); //constant

        if (GetAllAirlineReq != null) {
          let GetAllAirlineRes = await apiGetAllAirline.getResponse(
            GetAllAirlineReq
          );
          if (VALIDATE_SUCCESS_RES(GetAllAirlineRes)) {
            returnValue = GetAllAirlineRes.data.data;
          } else {
            let error = getErrorMessage(GetAllAirlineRes);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.showAlert(getErrorAlertValue(error));
            }
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CONTRACT,
          "error in  getGetAllAirline",
          err.toString(),
          "getGetAllAirline()",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return returnValue;
    },

    async getCrsProviders() {
      if (BaseConfiguration.isDebug) console.log("GetCrsProviders");
      let returnValue;
      try {
        let GetCrsProvidersReq = apiGetCrsProviders.buildRequest(); //constant

        if (GetCrsProvidersReq != null) {
          let GetCrsProvidersRes = await apiGetCrsProviders.getResponse(
            GetCrsProvidersReq
          );
          if (VALIDATE_SUCCESS_RES(GetCrsProvidersRes)) {
            returnValue = GetCrsProvidersRes.data.data;
          } else {
            let error = getErrorMessage(GetCrsProvidersRes);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.showAlert(getErrorAlertValue(error));
            }
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CONTRACT,
          "error in  getGetCrsProviders",
          err.toString(),
          "getGetCrsProviders()",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return returnValue;
    },

    onAirlineChange(pSelAirline) {
      try {
        if (BaseConfiguration.isDebug) console.log("onAirlineChange");
        this.contract.airline = pSelAirline;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.CONTRACT_NEW,
          "error in onAirlineChange",
          err.toString(),
          "onAirlineChange",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    onFareOnlyChange() {
      try {
        if (BaseConfiguration.isDebug) console.log("onFareOnlyChange");
        this.contract.isCrs = !this.contract.isCrs;
        if(!this.contract.isCrs){
          this.contract.providerid=null;
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.CONTRACT_NEW,
          "error in onFareOnlyChange",
          err.toString(),
          "onFareOnlyChange",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    onCrsChange(pSelCrs) {
      try {
        if (BaseConfiguration.isDebug) console.log("onCrsChange");
        this.contract.providerid = pSelCrs;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.CONTRACT_NEW,
          "error in onCrsChange",
          err.toString(),
          "onCrsChange",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    isValidData(pContractObj) {
      let retValue;
        try {
          if(BaseConfiguration.isDebug) console.log("isValidData");
          //removed Airline code condition  (&& pContractObj.airline!=null) 
          if(pContractObj.contractcode!=null && pContractObj.description!=null &&
              pContractObj.travelDate.to>=pContractObj.travelDate.from && 
                    pContractObj.ticketingDate.to >= pContractObj.ticketingDate.from  ){
                    //   && 
                    //  pContractObj.ticketingDate.to >= pContractObj.travelDate.from &&
                    //   pContractObj.ticketingDate.from >= pContractObj.travelDate.from
            if(pContractObj.isCrs==true){
              if(pContractObj.providerid!=null) {
                retValue = true;
              } else{
                retValue = false
              }
            } else{
              retValue = true;
            }
          } else{
            retValue = false;
          }
    
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.CONTRACT_NEW,
                  "error in isValidData",
                  err.toString(),
                  "isValidData",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
    }, 

    toSaveContract() {
                try {
                    if (BaseConfiguration.isDebug) console.log("toSaveContract");
                    let isValid = this.isValidData(this.contract);
                    if(isValid)
                    {
                    this.GET_SELECTED_CONTRACT? 
                    this.showAlertModal(
                        ALERT_MODAL_STATUS.INFO,
                        this.$t("addContract.editConfirm")
                    ):this.showAlertModal(
                        ALERT_MODAL_STATUS.INFO,
                        this.$t("addContract.addConfirm")
                    );
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.EXTENSION_SETUP,
                        "error in toSaveContract",
                        err.toString(),
                        "toSaveContract",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                // return retValue;
  },

            showAlertModal(status, val) {
                this.isShowAlertModal = true;
                this.alertCount += 1;
                this.modalStatus = status;

                if (status == ALERT_MODAL_STATUS.INFO) {
                    this.modalButton = [
                        {
                            name: this.$t("addContract.cancel"),
                            func: this.toggleShowAlertModal
                        },
                        {
                            name: this.$t("addContract.yes"),
                            func: this.GET_SELECTED_CONTRACT?
                                  this.updateContract : this.createContract
                        }
                    ];
                } else if (status == ALERT_MODAL_STATUS.SUCCESS ) {
                    this.modalButton = [
                        {
                            name: this.$t("addContract.ok"),
                            func: this.navigateToAllCont
                        }
                    ];
                }

                else if( status == ALERT_MODAL_STATUS.FAIL)
                {
                     this.modalButton = [
                        {
                            name: this.$t("addContract.ok"),
                            func:this.toggleShowAlertModal
                             
                        }
                    ];
                }
                this.confirmTxt = val;
            },

            navigateToAllCont() {
                this.isShowAlertModal = !this.isShowAlertModal;
                updateDataEdited(false);
                navigate(PATHNAME.CONTRACT_ALL);
                this.modalStatus = ALERT_MODAL_STATUS.INFO;
            },

             toggleShowAlertModal() {
              //  updateDataEdited(true);
                this.isShowAlertModal = !this.isShowAlertModal;
                this.modalStatus = ALERT_MODAL_STATUS.INFO;
            },


    assignContractObj(pAirilnrOp, pCrsOp,pSelContract) {
        try {
          if(BaseConfiguration.isDebug) console.log("assignContractObj");
          
        this.contract.contractcode = pSelContract.contractcode;
        this.contract.description = pSelContract.description;
        for(let i=0; i<pAirilnrOp.length; i++){
          if(pAirilnrOp[i].airline_code == pSelContract.airline_code){
            this.contract.airline = pAirilnrOp[i];
            break;
          }else{
            this.contract.airline =null;
          }
        }
        for(let i=0; i<pCrsOp.length; i++){
          if(pCrsOp[i].providertype == pSelContract.providerid){
            this.contract.providerid = pCrsOp[i];
            break;
          }else{
            this.contract.providerid=null;
          }
        }
        this.contract.travelDate.from = new Date(pSelContract.traveldate_from);
        this.contract.travelDate.to = new Date(pSelContract.traveldate_to);
        this.contract.ticketingDate.from = new Date(pSelContract.ticketingdate_from);
        this.contract.ticketingDate.to = new Date(pSelContract.ticketingdate_to);
        this.contract.isActive = pSelContract.isactive;
        this.contract.departureCurrency=pSelContract.departurecurrency;
        
    
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.CONTRACT_NEW,
                  "error in assignContractObj",
                  err.toString(),
                  "assignContractObj",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          
    }, 
    getDefAirlineObj(pLsAirline) {
       let retValue;
        try {
          if(BaseConfiguration.isDebug) console.log("getDefAirlineObj");
         for(let i=0;i<pLsAirline.length;i++){
           if(pLsAirline[i].airline_code==BaseConfiguration.defaultAirlineCode){
              retValue=pLsAirline[i];
              break;
           }
         }
    
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.CONTRACT_NEW,
                  "error in getDefAirlineObj",
                  err.toString(),
                  "getDefAirlineObj",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
        }, 
  },

  async created() {
    try {

      if(this.GET_SELECTED_CONTRACT){
       this.contract.isActive =  this.GET_SELECTED_CONTRACT.isactive;

this.defaultCurrency=this.GET_SELECTED_CONTRACT.nuclearcurrency;
        this.defaultCountryCode=this.GET_SELECTED_CONTRACT.home_country;
      }
    

      this.airlineOption = await this.getAllAirline();

      this.crsOption = await this.getCrsProviders();

      

      if(this.GET_SELECTED_CONTRACT && this.airlineOption && this.crsOption) {
        this.assignContractObj(this.airlineOption,this.crsOption, this.GET_SELECTED_CONTRACT);
        
         this.updateDepBasedCurr(this.contract.departureCurrency?0:1);          

      }else{
        if(this.airlineOption){
        let defAirline=this.getDefAirlineObj(this.airlineOption);
        if(defAirline){
          this.contract.airline=defAirline;  
        }
        }
      }
      
                 updateDataEdited(true);
    } catch (err) {
      let body = Logger.buildRequest(
        COMPONENT_NAME.CONTRACT_NEW,
        "error in  Created",
        err.toString(),
        "created",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
  },
  computed: {
    ...mapGetters("sContract", {
      GET_SELECTED_CONTRACT: "GET_SELECTED_CONTRACT"
    }),
  },
  beforeCreate() {
    addClassToBody(COMPONENT_NAME.CONTRACT_NEW);
  },

  beforeDestroy() {
    removeClassBody();
  }
};
</script>
